// extracted by mini-css-extract-plugin
export default {"card":"styles_card__3pWCe","icon__con":"styles_icon__con__uvNa4","title":"styles_title__Qzr4R","content":"styles_content__XT6JM","btn":"styles_btn__9LBOy"};